// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2wM1X","col":"styles_col__N7Z3h"};